import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { BASE_URL } from '../../api/userApi';

const Offers = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${BASE_URL}/products/products/`);
        if (response.ok) {
          const data = await response.json();
          
          // First filter products with active offers
          const productsWithOffers = data.filter(
            product => product.active_offers && product.active_offers.length > 0
          );

          // Then transform the filtered products
          const transformedProducts = productsWithOffers.map(product => ({
            id: product.id,
            name: product.name,
            brand: product.brand?.name || '',
            price: parseFloat(product.price),
            salePrice: parseFloat(product.sale_price),
            finalPrice: parseFloat(product.final_price),
            stock: product.variants.reduce((total, variant) => total + variant.stock, 0),
            // Calculate discount based on offer type
            discount: product.active_offers[0]?.offer_type === 'PERCENTAGE' 
              ? parseFloat(product.active_offers[0].discount_value)
              : product.active_offers[0]?.offer_type === 'FIXED'
                ? Math.round((parseFloat(product.active_offers[0].discount_value) / parseFloat(product.price)) * 100)
                : Math.round(((parseFloat(product.price) - parseFloat(product.sale_price)) / parseFloat(product.price)) * 100),
            variants: product.variants.map(variant => ({
              ...variant,
              images: variant.images.map(img => ({
                url: img.images,
                alt: `${product.name} - ${variant.color}`
              }))
            })),
            images: product.variants.reduce((acc, variant) => {
              if (acc.length === 0 && variant.images.length > 0) {
                return variant.images.map(img => ({
                  url: img.images,
                  alt: `${product.name} - ${variant.color}`
                }));
              }
              return acc;
            }, []),
            category: {
              id: product.category.id,
              name: product.category.name
            },
            // Include active offers in transformed data
            activeOffers: product.active_offers
          }));

          setProducts(transformedProducts);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-center min-h-[200px]">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading offers...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Special Offers</h1>
        <p className="text-gray-600 mt-2">Discover our amazing deals and discounts</p>
      </div>

      {products.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow-sm">
          <p className="text-gray-500 text-lg">No active offers at the moment</p>
          <Link 
            to="/products" 
            className="mt-4 inline-block text-indigo-600 hover:text-indigo-800 font-medium"
          >
            Browse all products
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Offers;



